module.exports = __webpack_public_path__ + "img/icon_map_32_off_101.0053fbc3.png";